import React from 'react';
import { Package, Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  const whatsappNumber = '50688937777';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer style={{ background: 'var(--sendhapy-teal)', color: 'white' }}>
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_fast-delivery-cr/artifacts/fmfxt8be_Captura%20de%20pantalla%202026-02-21%20144642.png"
                alt="SendHapy Logo"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm opacity-90 mb-4">
              Tu conexión directa entre Miami y Costa Rica.
            </p>
            <p className="text-sm font-semibold" style={{ color: 'var(--sendhapy-yellow)' }}>
              Rápido | Seguro | Confiable
            </p>
            
            {/* Redes Sociales */}
            <div className="flex items-center gap-3 mt-4">
              <a 
                href="https://instagram.com/send.hapy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-yellow-400 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={24} />
              </a>
              <a 
                href="https://facebook.com/profile.php?id=61553931707213"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-yellow-400 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={24} />
              </a>
              <a 
                href="mailto:hola@sendhapy.com"
                className="text-white hover:text-yellow-400 transition-colors"
                aria-label="Email"
              >
                <Mail size={24} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: 'var(--sendhapy-yellow)' }}>
              Enlaces Rápidos
            </h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('tracking')}
                  className="text-sm opacity-90 hover:opacity-100 transition-opacity"
                >
                  Consultar Tracking
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('casillero')}
                  className="text-sm opacity-90 hover:opacity-100 transition-opacity"
                >
                  Obtener Casillero
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="text-sm opacity-90 hover:opacity-100 transition-opacity"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: 'var(--sendhapy-yellow)' }}>
              Contacto
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <Mail size={16} className="mt-1 flex-shrink-0" style={{ color: 'var(--sendhapy-yellow)' }} />
                <div>
                  <a href="mailto:hola@sendhapy.com" className="hover:underline">
                    hola@sendhapy.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0" style={{ color: 'var(--sendhapy-yellow)' }} />
                <div>
                  <div>+506 8893-7777</div>
                  <div className="text-xs opacity-75">Lunes a Viernes</div>
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0" style={{ color: 'var(--sendhapy-yellow)' }} />
                <div>
                  <div>Miami, FL → Costa Rica</div>
                  <div className="text-xs opacity-75">Servicio Internacional</div>
                </div>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: 'var(--sendhapy-yellow)' }}>
              ¿Necesitas ayuda?
            </h3>
            <p className="text-sm opacity-90 mb-4">
              Contáctanos directamente
            </p>
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-sendhapy-primary inline-flex"
            >
              <Phone size={18} />
              WhatsApp
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p className="text-sm opacity-75">
            © 2024 SendHapy. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
